<!-- <div class="pay-card">
    <div class="icon">
        <i class="dx-icon-money text-white" style="font-size: 20px"></i>
    </div>

    <div class="d-flex justify-content-between align-items-center w-100">
        <span class="label">Payment Mode</span>
        <span class="value">Invoice</span>
    </div>
</div> -->

<section class="wrap">
    <h3 class="d-flex justify-content-between mb-4">
        <div class="title">
            <i class="dx-icon-money" style="font-size: 30px"></i>
            Payment Options
        </div>
        <span style="font-size: 14px;" *ngIf="trialDays > 0" class="trial-days">
            Start your {{trialDays}} Day trial now.
        </span>
    </h3>
    
    <!-- INVOICE OPTION -->
    <label class="option" [class.option--active]="selected">
        <input [disabled]="disabled" type="radio" name="payment" class="option__radio" [checked]="selected"
            (change)="choose('invoice')" aria-label="Pay via Invoicing / Bank Transfer" />
        <div class="option__icon" aria-hidden="true"><mat-icon>receipt_long</mat-icon></div>
        <div class="option__content">
            <div class="option__heading">Invoicing</div>
            <div class="option__sub">Receive an invoice directly to mail</div>
        </div>
    </label>

    <!-- CARD OPTION -->
    <label class="option disabled" [class.option--active]="selected === 'card'">
        <input disabled="true" type="radio" name="payment" class="option__radio" [checked]="selected === 'card'"
            (change)="choose('card')" aria-label="Pay with Credit / Debit / ATM Card" />
        <div class="option__icon" aria-hidden="true"><mat-icon>credit_card</mat-icon></div>
        <div class="option__content">
            <div class="option__heading">Credit / Debit Card</div>
            <div class="option__sub">Add and secure cards</div>
        </div>
    </label>

</section>